
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/sense-verbs-explanation';
const mainimage = '/Images/sense2.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "sense" },
];


const SenseVerbs = () => (
  <GrammarPageLayout
    level="B1"
    title="Sense Verbs"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Sense Verbs Exercises"
    seoDescription="Use see, hear, feel, watch correctly with infinitives or -ing forms. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default SenseVerbs;
